import { isIpAddress } from "../isIpAddress";
import { isValidHostLabel } from "../isValidHostLabel";
export const isVirtualHostableS3Bucket = function (value) {
  let allowSubDomains = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (allowSubDomains) {
    for (const label of value.split(".")) {
      if (!isVirtualHostableS3Bucket(label)) {
        return false;
      }
    }
    return true;
  }
  if (!isValidHostLabel(value)) {
    return false;
  }
  if (value.length < 3 || value.length > 63) {
    return false;
  }
  if (value !== value.toLowerCase()) {
    return false;
  }
  if (isIpAddress(value)) {
    return false;
  }
  return true;
};